// PDF del sistema: se abren en una pestaña nueva (NO se descargan a la computadora).
// ventana (opcional): pestaña abierta ANTES de un proceso largo (fotos, consultas) para que
// el navegador no la bloquee como ventana emergente.
function abrirEnPestana(doc, ventana) {
  const url = doc.output("bloburl");
  if (ventana && !ventana.closed) {
    ventana.location.href = url;
    return ventana;
  }
  const w = window.open(url, "_blank");
  if (!w) {
    window.alert(
      "El navegador bloqueó la pestaña del PDF.\nPermite las ventanas emergentes de este sitio (ícono en la barra de direcciones) y vuelve a intentarlo."
    );
  }
  return w;
}

// Abre el PDF en una pestaña nueva y ya (la regla para todo el sistema)
export function abrirPDF(doc, ventana) {
  return abrirEnPestana(doc, ventana);
}

// PDF que ya vienen hechos (CFDI timbrado de Facturama): pestaña nueva, sin descargar
export function abrirPDFBlob(blob) {
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    window.alert(
      "El navegador bloqueó la pestaña del PDF.\nPermite las ventanas emergentes de este sitio (ícono en la barra de direcciones) y vuelve a intentarlo."
    );
  }
  // Se libera después: la pestaña necesita el documento mientras carga
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
